module.exports = __webpack_public_path__ + "img/map3.8c65d1f0.jpg";